module.exports = __webpack_public_path__ + "static/img/press8.feaecf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press8.png
// module id = NSx4
// module chunks = 0